/**
 * use-user-tags — 全局用户标签定义 API（ADM-USR-S008）
 *
 * 契约 A3 §11。不传 app_id。DELETE 恒拒，前端不暴露删除 API。
 */

import type {
  CreateUserTagRequest,
  ToggleUserTagActiveRequest,
  UpdateUserTagRequest,
  UserTagDto,
} from '@novel-admin/shared';
import { type OffsetPagedResult, apiRequest, apiRequestOffsetPaged } from '~/api/client';

export const userTagsApi = {
  list: (
    page: number,
    limit: number,
    filters?: { binding_status?: 'bound' | 'unbound'; is_active?: boolean },
  ): Promise<OffsetPagedResult<UserTagDto>> =>
    apiRequestOffsetPaged<UserTagDto>({
      method: 'GET',
      path: '/api/v1/user-tags',
      query: {
        page,
        limit,
        ...(filters?.binding_status ? { binding_status: filters.binding_status } : {}),
        ...(filters?.is_active === undefined ? {} : { is_active: filters.is_active }),
      },
    }),
  create: (body: CreateUserTagRequest): Promise<UserTagDto> =>
    apiRequest<UserTagDto>({ method: 'POST', path: '/api/v1/user-tags', body }),
  update: (id: string, body: UpdateUserTagRequest): Promise<UserTagDto> =>
    apiRequest<UserTagDto>({ method: 'PATCH', path: `/api/v1/user-tags/${id}`, body }),
  toggle: (id: string, body: ToggleUserTagActiveRequest): Promise<UserTagDto> =>
    apiRequest<UserTagDto>({ method: 'PATCH', path: `/api/v1/user-tags/${id}/active`, body }),
};
